module.exports = __webpack_public_path__ + "img/mile6-m@2.150e2de2.jpg";